(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/reflection"), require("@bingads-webui/registry"), require("@bingads-webui/edm-shared"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui-universal/primitive-utilities", "@bingads-webui/reflection", "@bingads-webui/registry", "@bingads-webui/edm-shared"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/reflection"), require("@bingads-webui/registry"), require("@bingads-webui/edm-shared")) : factory(root["underscore"], root["@bingads-webui-universal/primitive-utilities"], root["@bingads-webui/reflection"], root["@bingads-webui/registry"], root["@bingads-webui/edm-shared"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__39__, __WEBPACK_EXTERNAL_MODULE__47__, __WEBPACK_EXTERNAL_MODULE__48__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ({

/***/ 39:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__39__;

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44);


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EDM", {
  enumerable: true,
  get: function get() {
    return _index.EDM;
  }
});

var _index = __webpack_require__(45);

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDM = void 0;

var _typesPlugin = _interopRequireDefault(__webpack_require__(46));

var _schemaPlugin = _interopRequireDefault(__webpack_require__(49));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * the Entity Data Model module
 */
class EDM {
  constructor(options) {
    (0, _typesPlugin.default)(this);

    if (options) {
      (0, _schemaPlugin.default)(this, options);
    }
  }

}

exports.EDM = EDM;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _reflection = __webpack_require__(39);

var _registry = __webpack_require__(47);

var _edmShared = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * the types plugin module
 */

/**
 * @param {EDM} edm - The EDM object to apply this plugin to
 * @return {void}
 */
var _default = edm => {
  if (edm.types) {
    return;
  } // eslint-disable-next-line no-undef


  const oneOfTypes = new Map();
  /**
   * @name edm
   * @type {EDM}
   * @property {Registry} types - A registry of all types
   * @property {Class} types.Type - The base type of all meta Types
   * @property {Class} types.PrimitiveType - The meta type of primitive types
   * @property {Class} types.ObjectType - The meta type of the key/value types
   * @property {Class} types.ComplexType - The meta type of the complex types
   * @property {Class} types.EntityType - The meta type of the entity types
   * @property {Class} types.CollectionType - The meta type of the collection types
   * @property {Class} types.CallableType - The meta type of the callable types
   */

  (0, _reflection.defineConstProperty)(edm, 'types', (() => {
    const types = new _registry.Registry();
    const Type = (0, _edmShared.createType)(types);
    const PrimitiveType = (0, _edmShared.createPrimitiveType)(Type);
    /**
     * @class OneOfType
     * @extends Type
     * @property {Class} types - Data could be one of these types
     * @see {@link http://json-schema.org/latest/json-schema-validation.html#rfc.section.6.7.3}
     */

    class OneOfType extends Type {
      /**
       * Create a PrimitiveType
       * @param {Object} options - The constructor options
       * @param {String} options.name - The name of the type
       * @param {Type[]} options.types - The JavaScript type of the primitive type
       * @return {void}
       */
      constructor({
        typeNames
      }) {
        super({
          name: OneOfType.oneOfTypeName(typeNames)
        });
        (0, _reflection.defineConstProperty)(this, 'typeNames', typeNames); // eslint-disable-next-line no-use-before-define

        (0, _reflection.defineConstProperty)(this, 'types', typeNames.map(typeName => resolveType(typeName, this.namespace)));
      }
      /**
       * Get the OneOfType's name from it's elements type name
       * @param {String[]} typeNames - The name of the elementTypes
       * @return {String} The name of the OneOfType
       */


      static oneOfTypeName(typeNames) {
        // We don't support nested one for now
        const sortedNames = typeNames.map(name => types.resolveQualifiedName(name, this.namespace)).sort();
        return `${_edmShared.ONEOF_TYPE_PREFIX}(${sortedNames.join(',')})`;
      }

    }

    const resolveType = (0, _edmShared.createResolveType)(oneOfTypes, types, OneOfType);
    const Property = (0, _edmShared.createProperty)(resolveType);
    const Parameter = (0, _edmShared.createParameter)(resolveType);
    /**
     * @class ObjectType
     * @extends Type
     * @property {Object.<String, Property>} properties - The properties of the object type
     * @property {String} baseTypeName - The name of the base type
     * @property {Type} baseType - The base type
     */

    class ObjectType extends Type {
      /**
       * Create an ObjectType
       * @param {Object} options - The constructor options
       * @param {String} options.name - The name of the type
       * @param {Object.<String, PropertyInfo>} options.properties - The property definition
       * @param {string[]} [options.navigationPropertyNames] - Navigation properties names
       * @param {String} options.baseTypeName - The name of the base type
       * @return {void}
       */
      constructor({
        name,
        properties,
        navigationPropertyNames = [],
        baseTypeName
      }) {
        super({
          name
        });
        (0, _reflection.defineConstProperty)(this, 'properties', _edmShared.compileProperties.call(this, properties, Property));
        (0, _reflection.defineConstProperty)(this, 'navigationPropertyNames', navigationPropertyNames.slice());
        (0, _reflection.defineProducedProperty)(this, 'navigationProperties', () => _underscore.default.pick(this.properties, (property, propertyName) => _underscore.default.contains(this.navigationPropertyNames, propertyName)));

        if (baseTypeName) {
          (0, _reflection.defineConstProperty)(this, 'baseTypeName', baseTypeName);
          (0, _reflection.defineProducedProperty)(this, 'baseType', () => resolveType(this.baseTypeName, this.namespace));
        }
      }

      addProperties(properties) {
        _underscore.default.extend(this.properties, _edmShared.compileProperties.call(this, properties, Property)); // only for backward compability, should use addNavigationProperties for this case


        this.navigationPropertyNames.push(..._underscore.default.keys(properties));
      }

      addNavigationProperties(properties) {
        this.addProperties(properties);
      }

    }
    /**
     * @class ComplexType
     * @extends ObjectType
     */


    class ComplexType extends ObjectType {}
    /**
     * @class EntityType
     * @extends ObjectType
     * @property {String} key - The name of the key property
     * @property {Property} keyProperty - The key property of the entity type
     * @return {void}
     */


    class EntityType extends ObjectType {
      /**
       * Create an EntityType
       * @param {Object} options - The constructor options
       * @param {String} options.name - The name of the type
       * @param {Object.<String, PropertyInfo>} options.properties - The property definition
       * @param {String} options.baseTypeName - The name of the base type
       * @param {String} [options.key] - The name of the key property
       * @return {void}
       */
      constructor({
        name,
        properties,
        navigationPropertyNames,
        baseTypeName,
        key
      }) {
        super({
          name,
          properties,
          navigationPropertyNames,
          baseTypeName
        });

        if (key) {
          (0, _reflection.defineConstProperty)(this, 'key', key);
          (0, _reflection.defineConstProperty)(this, 'keyProperty', this.properties[this.key]);
        } else if (baseTypeName) {
          // The key property is inherited if there's a base type
          (0, _reflection.defineProducedProperty)(this, 'key', () => this.baseType.key);
          (0, _reflection.defineProducedProperty)(this, 'keyProperty', () => this.baseType.keyProperty);
        } else {
          throw new Error('The "key" property is required for an EntityType');
        }
      }

    }

    const CollectionType = (0, _edmShared.createCollectionType)(ObjectType, resolveType);
    /**
     * @memberof Type#
     * @this Type
     * @returns {CollectionType} The CollectionType of the given Type
     */

    function collectionTypeFactory() {
      return new CollectionType({
        elementTypeName: this.name
      });
    }
    /**
     * @name type
     * @type Type
     * @property {CollectionType} collectionType - The collection type of the given type
     */


    (0, _reflection.defineProducedPropertyOnClass)(Type, 'collectionType', collectionTypeFactory);
    /**
     * @class CallableType
     * @property {Parameter[]} parameters - The parameters required to call the callable
     * @property {String} returnTypeName - The name of the return type
     * @property {Type} returnType - The return type of the callable
     */

    class CallableType extends Type {
      /**
       * Create a CallableType
       * @param {Object} options - The constructor options
       * @param {String} options.name - The name of the type
       * @param {Object.<String, ParameterInfo>} parameters - The parameter definitions
       * @param {String} returnTypeName - The name of the return type
       * @return {void}
       */
      constructor({
        name,
        callableName,
        parameters,
        returnTypeName
      }) {
        super({
          name
        });
        (0, _reflection.defineConstProperty)(this, 'callableName', callableName);
        (0, _reflection.defineConstProperty)(this, 'parameters', _edmShared.compileParameters.call(this, parameters, Parameter));
        (0, _reflection.defineConstProperty)(this, 'returnTypeName', returnTypeName);
        (0, _reflection.defineProducedProperty)(this, 'returnType', () => resolveType(returnTypeName, this.namespace));
      }

    }
    /**
     * @class ActionType
     * @property {Parameter[]} parameters - The parameters required to call the callable
     * @property {String} returnTypeName - The name of the return type
     * @property {Type} returnType - The return type of the callable
     */


    class ActionType extends CallableType {
      /**
       * Create a CallableType
       * @param {Object} options - The constructor options
       * @param {String} options.name - The name of the type
       * @param {Object.<String, ParameterInfo>} parameters - The parameter definitions
       * @param {String} returnTypeName - The name of the return type
       * @return {void}
       */
      constructor({
        name,
        callableName,
        parameters,
        returnTypeName
      }) {
        super({
          name,
          callableName,
          parameters,
          returnTypeName
        });
      }

    }
    /**
     * @class FunctionType
     * @property {Parameter[]} parameters - The parameters required to call the callable
     * @property {String} returnTypeName - The name of the return type
     * @property {Type} returnType - The return type of the callable
     */


    class FunctionType extends CallableType {
      /**
       * Create a CallableType
       * @param {Object} options - The constructor options
       * @param {String} options.name - The name of the type
       * @param {Object.<String, ParameterInfo>} parameters - The parameter definitions
       * @param {String} returnTypeName - The name of the return type
       * @return {void}
       */
      constructor({
        name,
        callableName,
        parameters,
        returnTypeName
      }) {
        super({
          name,
          callableName,
          parameters,
          returnTypeName
        });
      }

    } // TODO: wewei, support EnumType


    (0, _reflection.defineConstProperty)(types, 'Property', Property);
    (0, _reflection.defineConstProperty)(types, 'Parameter', Parameter);
    (0, _reflection.defineConstProperty)(types, 'Type', Type);
    (0, _reflection.defineConstProperty)(types, 'PrimitiveType', PrimitiveType);
    (0, _reflection.defineConstProperty)(types, 'OneOfType', OneOfType);
    (0, _reflection.defineConstProperty)(types, 'ObjectType', ObjectType);
    (0, _reflection.defineConstProperty)(types, 'ComplexType', ComplexType);
    (0, _reflection.defineConstProperty)(types, 'EntityType', EntityType);
    (0, _reflection.defineConstProperty)(types, 'CollectionType', CollectionType);
    (0, _reflection.defineConstProperty)(types, 'CallableType', CallableType);
    (0, _reflection.defineConstProperty)(types, 'ActionType', ActionType);
    (0, _reflection.defineConstProperty)(types, 'FunctionType', FunctionType);
    return types;
  })());
};

exports.default = _default;

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__47__;

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__48__;

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _primitiveUtilities = __webpack_require__(8);

var _reflection = __webpack_require__(39);

var _registry = __webpack_require__(47);

var _typesPlugin = _interopRequireDefault(__webpack_require__(46));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * the schema plugin module
 */
function getSchemaName(schema) {
  const $$ODataExtension = schema.$$ODataExtension,
        name = schema.name;

  if ($$ODataExtension) {
    return $$ODataExtension.Name;
  } // deprecated
  // There is no such keyword as "name" in JSON Schema, it's specific to OData
  // See:
  //  http://json-schema.org/latest/json-schema-core.html
  //  http://json-schema.org/latest/json-schema-validation.html


  return name;
}

function getSchemaBaseTypeName(schema) {
  const $$ODataExtension = schema.$$ODataExtension,
        clrTypeBase = schema.clrTypeBase;

  if ($$ODataExtension) {
    return $$ODataExtension.BaseType && $$ODataExtension.BaseType.$ref;
  } // deprecated
  // There is no such keyword as "clrTypeBase" in JSON Schema, it's specific to OData
  // See:
  //  http://json-schema.org/latest/json-schema-core.html
  //  http://json-schema.org/latest/json-schema-validation.html


  return clrTypeBase;
}

function getSchemaKey(schema) {
  const $$ODataExtension = schema.$$ODataExtension,
        key = schema.key;

  if ($$ODataExtension) {
    return $$ODataExtension.Key;
  } // deprecated
  // There is no such keyword as "key" in JSON Schema, it's specific to OData
  // See:
  //  http://json-schema.org/latest/json-schema-core.html
  //  http://json-schema.org/latest/json-schema-validation.html


  return key;
}

function getSchemaNavigationPropertyNames(schema) {
  const $$ODataExtension = schema.$$ODataExtension;

  if ($$ODataExtension) {
    return $$ODataExtension.NavigationProperty;
  }

  return [];
}

var _default = (edm, {
  schemas = {},
  // TODO: deprecated, every schemas should be able to have different namespaces
  // we are still using it with legacy schemas
  namespace = null
} = {}) => {
  if ((0, _reflection.hasOwnProperty)(edm, 'schema')) {
    return;
  }

  (0, _typesPlugin.default)(edm);
  const _edm$types = edm.types,
        CollectionType = _edm$types.CollectionType,
        EntityType = _edm$types.EntityType,
        PrimitiveType = _edm$types.PrimitiveType,
        ComplexType = _edm$types.ComplexType,
        OneOfType = _edm$types.OneOfType,
        ActionType = _edm$types.ActionType,
        FunctionType = _edm$types.FunctionType;
  (0, _reflection.defineConstProperty)(edm, 'schema', (() => {
    function getSchemaFullName(schema, path) {
      // $$ref exists in resolved schema
      const possiblePath = _underscore.default.isString(path) && path || schema.$$ref || schema.$ref;
      return possiblePath ? possiblePath.replace(/\//g, '.') : _registry.Registry.getQualifiedName(getSchemaName(schema), namespace);
    }
    /**
     * Get type name object with its information
     * @param {Schema[]} dependencies - An output paramter, a queue of dependent schemas
     * @param {Object} typeInfo - The schema information of the property
     * @return {String} The type name
     */


    function getTypeName(dependencies, typeInfo) {
      let schema = null;
      let typeName = null;

      if (!typeInfo) {
        return null;
      }

      if (typeInfo.type === 'array') {
        return CollectionType.collectionTypeName(getTypeName(dependencies, typeInfo.items));
      } else if (typeInfo.oneOf) {
        return OneOfType.oneOfTypeName(typeInfo.oneOf.map(item => getTypeName(dependencies, item)));
      } else if (typeInfo.type === 'object') {
        schema = typeInfo.schema;
        // it's possible for the schema to be undefined, use 'object' type by default
        typeName = getSchemaFullName(schema || typeInfo);
      } else if (typeInfo.type === 'string' && typeInfo.enum) {
        // enum type is string, but we need to get a meanful name for different enum type
        // this is to help us disable cache accurately, as enum can be odata call return type now
        typeName = (typeInfo.$$ref || 'string').split('/').join('.');
      } else {
        // primitive types
        typeName = typeInfo.type;
      }

      if (schema) {
        dependencies.push(schema);
      }

      return typeName;
    }

    function defineCallableOnType(acts, funcs, type, qualifiedName, forEntityType = true) {
      const actions = [];
      const functions = [];

      function getCallableTypeName(key) {
        return `${key}##${qualifiedName}${forEntityType ? '' : '@@COLL'}`;
      }

      _underscore.default.each(_underscore.default.keys(acts), key => {
        const typeName = getCallableTypeName(key);

        const parameters = _underscore.default.mapObject(acts[key].Parameter, parameter => getTypeName([], parameter));

        actions.push(new ActionType({
          name: typeName,
          callableName: key,
          parameters,
          returnTypeName: getTypeName([], acts[key].ReturnType)
        }));
      });

      _underscore.default.each(_underscore.default.keys(funcs), key => {
        const typeName = getCallableTypeName(key);

        const parameters = _underscore.default.mapObject(funcs[key].Parameter, parameter => getTypeName([], parameter));

        functions.push(new FunctionType({
          name: typeName,
          callableName: key,
          parameters,
          returnTypeName: getTypeName([], funcs[key].ReturnType)
        }));
      });

      (0, _reflection.defineConstProperty)(type, 'callable', {
        actions,
        functions
      });
    }
    /**
     * Define an entity type, and its dependencies
     *
     * @param {Schema} schema - The schema for the entity type
     * @param {string} [path] - Possible full path of the schema
     * @return {Void} Nothing to return
     */


    function defineSchemaType(schema, path) {
      const qualifiedName = getSchemaFullName(schema, path);

      if (!edm.types.resolve(qualifiedName)) {
        const dependencies = [];

        const properties = _underscore.default.mapObject(schema.properties, typeInfo => ({
          typeName: getTypeName(dependencies, typeInfo)
        }));

        const type = new EntityType({
          name: qualifiedName,
          baseTypeName: getSchemaBaseTypeName(schema) || 'object',
          key: getSchemaKey(schema),
          properties,
          navigationPropertyNames: getSchemaNavigationPropertyNames(schema)
        });
        (0, _reflection.defineConstProperty)(type, 'schema', schema);

        _underscore.default.each(dependencies, defineSchemaType);

        const entityActions = (0, _primitiveUtilities.get)(schema, '$$ODataExtension.Action', null);
        const entityFunctions = (0, _primitiveUtilities.get)(schema, '$$ODataExtension.Function', null);

        if (entityActions || entityFunctions) {
          defineCallableOnType(entityActions, entityFunctions, type, qualifiedName);
        }

        const collCallable = (0, _primitiveUtilities.get)(schema, '$$ODataExtension.Collection', null);

        if (collCallable) {
          defineCallableOnType(collCallable.Action, collCallable.Function, type.collectionType, qualifiedName, false);
        }
      }
    } // Define all the primitive types


    _underscore.default.each({
      string: String,
      integer: Number,
      number: Number,
      datetime: Date,
      boolean: Boolean,
      null: null
    }, (jsType, name) => new PrimitiveType({
      name,
      jsType
    })); // Define the base object type

    /* eslint no-new: 0 */


    new ComplexType({
      name: 'object',
      properties: {}
    });

    _underscore.default.each(schemas, (schema, index) => {
      if (_underscore.default.isString(index)) {
        defineSchemaType(schema, index);
      } else {
        defineSchemaType(schema);
      }
    });

    return _underscore.default.chain({}).defineConstProperty('schemas', schemas).defineConstProperty('namespace', namespace).value();
  })());
};

exports.default = _default;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});
